export const theme = {
	borderRadius: {
		default: '16px',
		mobileXL: '8px',
	},
};
